define(["backbone", "../baseModels/collaborationFeaturesModel"], function (
  Backbone,
  CollaborationFeaturesModel,
) {
  "use strict";
  const RevisionHistoryModel = {};

  RevisionHistoryModel.revision = CollaborationFeaturesModel.base.extend({
    idAttribute: "id",
    defaults: {
      ckRevisionId: "",
      templateId: 0,
      diffData: "",
      name: "",
    },
  });

  RevisionHistoryModel.revisions = Backbone.Collection.extend({
    model: RevisionHistoryModel.revision,
  });

  return RevisionHistoryModel;
});
